import { FC, useRef, ReactNode, useMemo } from 'react';
// 组件
import { ProModal } from '../antd';
import LayOutPage from '../LayOutPage';
import Detail from './subpage/detail';
import SuperTable from '../SuperTable';
// 方法
import { responseSuccess, responseError } from '../utils/messageUtils';
// 常量
import { SimpleListPageProps } from './interface';
import { DetailBaseActionType } from '../constants/interface';
import { TableActionType } from '../SuperTable/interface';
import { EditTypeEnum } from '../constants/enum';
import { SUCCESS_STATUS_CODE } from '../constants/constant';
import { getOperationBtns, getHeadOperationBtns } from './tableCofig';
/** 简单列表+详情 */
const SimpleListPageNew: FC<SimpleListPageProps> = props => {
  const { idKey, authority, listProps, detailProps, actionRef, } = props;
  const { nameKey, deleteApi, deleteTitle, ...restListProps } = listProps;
  const tableRef = useRef<TableActionType>();
  const detailRef = useRef<DetailBaseActionType>();
  // 点击操作按钮
  const handleClickOperation = (key: string | number, record: any) => {
    if (key === EditTypeEnum.detail)
      return detailRef.current?.detail?.(record[idKey]);
    if (key === EditTypeEnum.edit)
      return detailRef.current?.edit?.(record[idKey]);
    if (key === EditTypeEnum.delete) return handleDelete(record);
  };
  // 点击新增
  const handleAdd = () => {
    detailRef.current?.add?.();
  };
  // 删除
  const handleDelete = (record: any) => {
    let rowName: string = '该条数据吗';
    if (nameKey) {
      rowName = typeof nameKey === 'string' ? record[nameKey] : nameKey(record);
    }
    let confimTitle: ReactNode = `确认删除 ${rowName ?? ''}？`;
    if (deleteTitle !== undefined) {
      confimTitle =
        typeof deleteTitle === 'function' ? deleteTitle(record) : deleteTitle;
    }
    ProModal.confirm({
      title: confimTitle,
      okText: '确定',
      cancelText: '取消',
      onOk: async () => {
        const res = await deleteApi(record[idKey]);
        if (res.code === SUCCESS_STATUS_CODE) {
          responseSuccess('删除成功');
          handleReload();
        } else {
          responseError(res);
        }
      },
    });
  };
  // 刷新
  const handleReload = () => {
    tableRef.current?.reload();
  };
  const operation = useMemo(() => {
    if (authority) {
      return getOperationBtns(authority);
    }
  }, [authority]);
  const headOperation = useMemo(() => {
    return getHeadOperationBtns(handleAdd, authority?.add);
  }, [authority?.add]);
  if (actionRef) {
    actionRef.current = {
      reload: handleReload,
    };
  }

  return (
    <LayOutPage>
      <LayOutPage.Content>
        <SuperTable
          rowKey={idKey}
          headOperation={headOperation}
          operation={operation}
          {...restListProps}
          actionRef={tableRef}
          onClickOperation={handleClickOperation}
        />
      </LayOutPage.Content>
      <LayOutPage.Detail>
        <Detail
          detailRef={detailRef}
          idKey={idKey}
          onReload={handleReload}
          isEditAuth={authority?.edit}
          {...detailProps}
        />
      </LayOutPage.Detail>
    </LayOutPage>
  );
};

export default SimpleListPageNew;
